import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Branched from '../MobileArtStage.multi_file_deviation';
import NonBranched from './MobileArtStage';
export default withFeatureBranch({
    multi_file_deviation: Branched
})(NonBranched);

//# sourceMappingURL=index.js.map